module.exports = __webpack_public_path__ + "img/维护.e7dd17fd.svg";